import React from 'react';
import { CHECKOUT_URL, PRODUCT_IMAGE, PRODUCT_NAME } from './constants';
interface ProductArtworkProps {
  className?: string;
}
export function ProductArtwork({
  className = ''
}: ProductArtworkProps) {
  return <a href={CHECKOUT_URL} aria-label={`Acheter ${PRODUCT_NAME}`} className="block focus:outline-none focus:ring-4 focus:ring-gold/40" data-id="element-162" data-mp="34q1eu50pi0zw">
      <img src={PRODUCT_IMAGE} alt="COACH FORCE PRO™ — système complet de planification pour coachs" className={`h-auto w-full object-contain ${className}`} data-id="element-163" data-mp="38qlbz8la54m1" />
    </a>;
}